import React from 'react'
import { Outlet } from 'react-router-dom'
import { useEvent } from '@/hooks/useEvent'
import { Badge } from '@/components/ui'
import type { EventStatus } from '@/lib/types'

const STATUS_TONE: Record<EventStatus, 'slate' | 'green' | 'amber' | 'blue'> = {
  draft: 'slate',
  active: 'green',
  closed: 'amber',
  archived: 'slate',
}

export default function EventShell() {
  const { event } = useEvent()
  return (
    <div>
      <div className="border-b border-slate-200 bg-white px-6 py-4">
        <div className="flex items-center gap-2">
          <h1 className="text-base font-semibold text-slate-900">{event.name}</h1>
          <Badge tone={STATUS_TONE[event.status]}>{event.status}</Badge>
        </div>
        <div className="text-xs text-slate-500">
          {event.code}
          {event.venue ? ` · ${event.venue}` : ''}
          {event.city ? `, ${event.city}` : ''}
        </div>
      </div>
      <Outlet />
    </div>
  )
}
